import { render, staticRenderFns } from "./FormReciboRenta.vue?vue&type=template&id=82d5f748&scoped=true&"
import script from "./FormReciboRenta.vue?vue&type=script&lang=js&"
export * from "./FormReciboRenta.vue?vue&type=script&lang=js&"
import style0 from "./FormReciboRenta.vue?vue&type=style&index=0&id=82d5f748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d5f748",
  null
  
)

export default component.exports